'use client';
"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkTMY5JA2Ajs = require('./chunk-TMY5JA2A.js');

// src/notificationBadge/NotificationBadge.tsx
var _jsxruntime = require('react/jsx-runtime');
var NotificationBadge = ({ className, count, maxCount = 99 }) => {
  if (count <= 0) {
    return null;
  }
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, 
    _chunkTMY5JA2Ajs.Badge,
    {
      className,
      color: "critical",
      dense: true,
      emphasis: "bold",
      round: true,
      size: "xs",
      children: count > maxCount ? `${maxCount}+` : count
    }
  );
};


exports.NotificationBadge = NotificationBadge;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9ub3RpZmljYXRpb25CYWRnZS9Ob3RpZmljYXRpb25CYWRnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFzQlE7QUFORCxJQUFNLG9CQUFvQixDQUFDLEVBQUUsV0FBVyxPQUFPLFdBQVcsR0FBRyxNQUFhO0FBQzdFLE1BQUksU0FBUyxHQUFHO0FBQ1osV0FBTztBQUFBLEVBQ1g7QUFFQSxTQUNJO0FBQUEsSUFBQztBQUFBO0FBQUEsTUFDRztBQUFBLE1BQ0EsT0FBTTtBQUFBLE1BQ04sT0FBSztBQUFBLE1BQ0wsVUFBUztBQUFBLE1BQ1QsT0FBSztBQUFBLE1BQ0wsTUFBSztBQUFBLE1BRUosa0JBQVEsV0FBVyxHQUFHLGNBQWM7QUFBQTtBQUFBLEVBQ3pDO0FBRVIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBCYWRnZSB9IGZyb20gJ3NyYy9iYWRnZS9CYWRnZSc7XG5cbnR5cGUgUHJvcHMgPSB7XG4gICAgLyoqXG4gICAgICogTm90aWZpY2F0aW9ucyBjb3VudCB0byByZW5kZXIuXG4gICAgICpcbiAgICAgKiBVc2FnZTpcbiAgICAgKiBgYGB0c3hcbiAgICAgKiA8Tm90aWZpY2F0aW9uQmFkZ2UgY291bnQ9ezEwfSAvPlxuICAgICAqIGBgYFxuICAgICAqL1xuICAgIGNsYXNzTmFtZT86IHN0cmluZztcbiAgICBjb3VudDogbnVtYmVyO1xuICAgIG1heENvdW50PzogbnVtYmVyO1xufTtcblxuZXhwb3J0IGNvbnN0IE5vdGlmaWNhdGlvbkJhZGdlID0gKHsgY2xhc3NOYW1lLCBjb3VudCwgbWF4Q291bnQgPSA5OSB9OiBQcm9wcykgPT4ge1xuICAgIGlmIChjb3VudCA8PSAwKSB7XG4gICAgICAgIHJldHVybiBudWxsO1xuICAgIH1cblxuICAgIHJldHVybiAoXG4gICAgICAgIDxCYWRnZVxuICAgICAgICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICAgICAgICBjb2xvcj1cImNyaXRpY2FsXCJcbiAgICAgICAgICAgIGRlbnNlXG4gICAgICAgICAgICBlbXBoYXNpcz1cImJvbGRcIlxuICAgICAgICAgICAgcm91bmRcbiAgICAgICAgICAgIHNpemU9XCJ4c1wiXG4gICAgICAgID5cbiAgICAgICAgICAgIHtjb3VudCA+IG1heENvdW50ID8gYCR7bWF4Q291bnR9K2AgOiBjb3VudH1cbiAgICAgICAgPC9CYWRnZT5cbiAgICApO1xufTtcbiJdfQ==